import Stats from "../../common/stats/stats";

export default class FootballStats extends Stats {
    constructor({ driveId, ...statRecord } = {}) {
        super(statRecord);
        Object.assign(this, { driveId });
    }
}
